


import { baseServiceUrl, DomainEnum, urls, EUserType } from "../environment";
import toast from "react-hot-toast";

import { useRestService } from "../hooks/useRestService";
import {
  DomainContextProps,
  DomainContextProviderProps,
} from "../types/DomainContextTypes";
import useAppLevelStores from "../stores/useAppLevelStores";

import useDomainStore from "../stores/useDomainStores";
import useUserDataStore from "../stores/useUserDataStore";

const useDomainService = (): DomainContextProps => {
  const restService = useRestService(baseServiceUrl);
  const userDetails = useUserDataStore();
  const appLevelContext = useAppLevelStores();
  const domainStoroes = useDomainStore();


  const getDomainCustomDataService = async({payload,successCallback,errorCallback}:{payload:string,successCallback?:(args?:any)=>void;errorCallback?:(args?:any)=>void})=>{
    try{
      appLevelContext.setIsLoading(true);
      const response = await restService.get(`${urls.domainExtraData}${payload}`)
      if(response  && response?.data){
        successCallback?.(response?.data);
      }

    }catch(error){
      errorCallback?.()
      toast.error("Something went wrong")
    }finally{
      appLevelContext.setIsLoading(false);
    }

  }

  const initDomain = () => {
    if (userDetails && userDetails?.userdetails && !!userDetails?.token) {
      (async () => {
        try {
          appLevelContext.setIsLoading(true);
          const [
            subjectsResponse,
            complexityResponse,
            marksResponse,
            langugageResponse,
          ] = await Promise.all([
            restService.get(baseServiceUrl + urls.getSubjectUrl),
            restService.get(baseServiceUrl + urls.getComplexityDomainUrl),
            restService.get(baseServiceUrl + urls.getMarksDomainUrl),
            restService.get(baseServiceUrl + urls.getLanguageDomainUrl),
          ]);

          
          
          if (subjectsResponse.data) {
            domainStoroes.setSubjects(subjectsResponse.data);
          }
          if (complexityResponse.data) {
            domainStoroes.setComplexity(complexityResponse.data);
          }
          if (langugageResponse.data) {
            domainStoroes.setLanguage(langugageResponse.data);
          }
          if (marksResponse.data) {
            domainStoroes.setMarks(marksResponse.data);
          }
        } catch (err: any) {
          toast.error(
            err?.response?.data?.message || "Error encounter. Please try again."
          );
        } finally {
          appLevelContext.setIsLoading(false);
        }
      })();
    }
  };

  const addNewDomain = async ({
    payload,
    successCallback,
  }: {
    payload: any;
    successCallback: any;
  }) => {
    try {
      appLevelContext.setIsLoading(true);
      await restService.post(baseServiceUrl + urls.addDomainURL, payload);
      switch (payload.domain_type) {
        case DomainEnum.COMPLEXITY:
          const complexityResponse = await restService.get(
            baseServiceUrl + urls.getComplexityDomainUrl
          );
          if (complexityResponse.data)
            domainStoroes.setComplexity(complexityResponse.data);
          break;
        case DomainEnum.LANGUAGE:
          const langugageResponse = await restService.get(
            baseServiceUrl + urls.getLanguageDomainUrl
          );
          if (langugageResponse.data)
            domainStoroes.setLanguage(langugageResponse.data);
          break;
        case DomainEnum.MARKS:
          const marksResponse = await restService.get(
            baseServiceUrl + urls.getMarksDomainUrl
          );
          if (marksResponse.data) domainStoroes.setMarks(marksResponse.data);
          break;
        case DomainEnum.SUBJECT:
          const subjectResponse = await restService.get(
            baseServiceUrl + urls.getSubjectUrl
          );
          if (subjectResponse.data)
            domainStoroes.setSubjects(subjectResponse.data);
      }
      successCallback?.();
    } catch (error) {
      toast.error("something went wrong");
    } finally {
      appLevelContext.setIsLoading(false);
    }
  };

  // ***************    Clear All DomainContext Data     ***************
  const resetDomainContext = () => {
    domainStoroes.setMarks([]);
    domainStoroes.setComplexity([]);
    domainStoroes.setLanguage([]);
    domainStoroes.setSubjects([]);
  };

  return {
    resetDomainContext,
    initDomain,
    getDomainCustomDataService,
    addNewDomain,
  };
};



export default useDomainService